import { observer } from "mobx-react";
import { useEffect, useState } from "react";
import { SingleValue } from "react-select";
import { FormField } from "../../../../../components/form-field/form-field";
import { Input } from "../../../../../components/inputs/input/input";
import { IOption, SelectDropdown } from "../../../../../components/inputs/select-dropdown/select-dropdown";
import { Textarea } from "../../../../../components/inputs/textarea/textarea";
import Card from "../../../../../components/layouts/card/card";
import { IValidationGroup } from "../../../../../hooks/validation-group/validation-group-hook";
import ControlGroup from "../../../../../components/layouts/control-group/control-group";
import SubscriptionPlanEditorStore from "../../../stores/subscription-plan-editor-store";
import plansCombinedStore from "../../../stores/plans-combined-store";

export interface ICardGeneralProps {
    validationGroup: IValidationGroup;
    store?: SubscriptionPlanEditorStore;
}

const typeOptions = [
    { value: 0, label: 'Regular' },
    { value: 1, label: 'Custom' },
];

const CardGeneral: React.FC<ICardGeneralProps> = observer(({ validationGroup, store }) => {
    const defaultTypeValue = store?.is_custom === true ? typeOptions[1]
        : store?.is_custom === false ? typeOptions[0] : undefined;

    const [typeValue, setTypeValue] = useState<SingleValue<IOption> | undefined>(defaultTypeValue);

    useEffect(() => {
        if (!typeValue && store?.is_custom !== undefined) {
            setTypeValue(store?.is_custom ? typeOptions[1] : typeOptions[0]);
        }
    }, [typeValue, store, store?.is_custom]);

    const onIsCustomChangeHandler = (singleValue: SingleValue<IOption>) => {
        if (singleValue) {
            if (store) {
                setTypeValue(singleValue);
                store.is_custom = Boolean(singleValue.value);
            }
        }
    }

    const partnerOptions = (): IOption[] => {
        const options = [
            { label: 'Choose partner' } as IOption
        ];

        if (plansCombinedStore.settings?.partners) {
            plansCombinedStore.settings.partners.forEach(p => {
                options.push({
                    value: p.id,
                    label: p.name,
                })
            });
        }

        return options;
    }
    const partnerValue = partnerOptions().find(p => p.value === store?.partnerId);
    const onPartnerValueChangeHnadler = (singleValue: SingleValue<IOption>) => {
        if (singleValue) {
            store?.setPartnerId(singleValue.value as string|undefined);
        }
    }

    return <Card
        disabled={store?.isInUse}
        toolbar={{
            title: "General"
        }}
    >
        <ControlGroup>
            <FormField label='Partner'>
            <SelectDropdown
                    value={partnerValue}
                    options={partnerOptions()}
                    onChange={onPartnerValueChangeHnadler}
                    placeholder='Choose partner'
                />
            </FormField>
        </ControlGroup>

        <ControlGroup>
            <FormField label='Name' required>
                <Input
                    required
                    value={store?.name}
                    onChange={store?.setName}
                    validationGroup={validationGroup}
                />
            </FormField>
            <FormField label='Type' required>
                <SelectDropdown
                    required
                    validationGroup={validationGroup}
                    value={typeValue}
                    options={typeOptions}
                    onChange={onIsCustomChangeHandler}
                    placeholder='Select a type'
                />
            </FormField>
        </ControlGroup>

        <FormField
            label="Terms & Conditions"
            tooltip={"This text will appear on Shopify's \"Approve billing page\""}
            required
        >
            <Textarea
                required
                value={store?.terms}
                onChange={store?.setTerms}
                validationGroup={validationGroup}
            />
        </FormField>
        <FormField label='Note'>
            <Input
                value={store?.internal_name}
                onChange={store?.setInternalName}
                placeholder="Add internal note"
            />
        </FormField>
    </Card>
});

export default CardGeneral;
